import useProductCountDown from 'utilities/hooks/countDownProduct/useProductCountDown';

const RemainingTime = ({remainingTime}: IRemainingTime) => {
  const {days, hours} = useProductCountDown(remainingTime);
  return (
    <div className=" flex justify-between mt-7">
      <div className="flex">
        <span className=" mt-1 ml-1 text-error icon-clock"></span>
        <p className=" text-error"> زمان باقی‌مانده:</p>
      </div>
      <p className=" text-error text-sm">
        {days} روز و {hours} ساعت مانده
      </p>
    </div>
  );
};

export default RemainingTime;
